import React, { useState, useRef } from 'react';
import coverlogo from '../../resources/coverlogo.png';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useCart } from '../../context/CartContext';
import coverlogo3 from '../../resources/coverlogo3.png';

const Navbar = () => {
  const { items } = useCart();
  const cartCount = items.length;
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [dropdownOpen2, setDropdownOpen2] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const dropdownTimeout = useRef(null);
  const dropdownTimeout2 = useRef(null);

  const handleMouseEnter = () => {
    clearTimeout(dropdownTimeout.current);
    setDropdownOpen(true);
  };
  const handleMouseLeave = () => {
    dropdownTimeout.current = setTimeout(() => setDropdownOpen(false), 200);
  };
  const handleMouseEnter2 = () => {
    clearTimeout(dropdownTimeout2.current);
    setDropdownOpen2(true);
  };
  const handleMouseLeave2 = () => {
    dropdownTimeout2.current = setTimeout(() => setDropdownOpen2(false), 200);
  };

  const NAV_LINK = "text-base text-stone-600 font-serif hover:text-[#C29979] px-3 py-2 rounded transition-colors";

  return (
    <nav className="bg-[#FEFAF4] border-b border-amber-200 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto flex items-center justify-between px-4 sm:px-6 h-28">

        {/* Logo */}
        <div className="absolute left-1/2 -translate-x-1/2 md:static md:translate-x-0">
          <img
            src={coverlogo3}
            alt="Kalla Bakarí"
            className="h-20 cursor-pointer"
            onClick={() => window.location.href = '/'}
          />
        </div>

        {/* Mobile hamburger */}
        <div className="md:hidden relative z-10 ml-auto">
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="text-stone-600 hover:text-[#C29979] p-2 transition-colors"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
              {mobileMenuOpen
                ? <><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></>
                : <><line x1="4" y1="6" x2="20" y2="6"/><line x1="4" y1="12" x2="20" y2="12"/><line x1="4" y1="18" x2="20" y2="18"/></>
              }
            </svg>
          </button>
        </div>

        {/* Desktop links */}
        <div className="hidden md:flex items-center justify-between w-full ml-8">
          <div className="flex items-center space-x-1">
            <button onClick={() => window.location.href = '/'} className={NAV_LINK}>Forsíða</button>

            {/* Vörur dropdown */}
            <div className="relative" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
              <button className={`${NAV_LINK} flex items-center`}>
                Vörur <ArrowDropDownIcon fontSize="small" />
              </button>
              {dropdownOpen && (
                <div className="absolute left-0 top-full mt-1 bg-white border border-amber-100 rounded-xl shadow-md w-44 py-1 z-20">
                  <a href="/braud" className="block px-4 py-2 text-stone-600 font-serif text-base hover:text-[#C29979] hover:bg-amber-50 transition-colors">Brauð</a>
                  <a href="/braudmeti" className="block px-4 py-2 text-stone-600 font-serif text-base hover:text-[#C29979] hover:bg-amber-50 transition-colors">Brauðmeti</a>
                  <a href="/bakkelsi" className="block px-4 py-2 text-stone-600 font-serif text-base hover:text-[#C29979] hover:bg-amber-50 transition-colors">Bakkelsi</a>
                  <a href="/smurt" className="block px-4 py-2 text-stone-600 font-serif text-base hover:text-[#C29979] hover:bg-amber-50 transition-colors">Smurt</a>
                </div>
              )}
            </div>

            <button onClick={() => window.location.href = '/kokur'} className={NAV_LINK}>Kökur</button>

            {/* Pantanir dropdown */}
            <div className="relative" onMouseEnter={handleMouseEnter2} onMouseLeave={handleMouseLeave2}>
              <button className={`${NAV_LINK} flex items-center`}>
                Pantanir <ArrowDropDownIcon fontSize="small" />
              </button>
              {dropdownOpen2 && (
                <div className="absolute left-0 top-full mt-1 bg-white border border-amber-100 rounded-xl shadow-md w-44 py-1 z-20">
                  <a href="/kokur" className="block px-4 py-2 text-stone-600 font-serif text-base hover:text-[#C29979] hover:bg-amber-50 transition-colors">Kökur</a>
                  <a href="/smarettir" className="block px-4 py-2 text-stone-600 font-serif text-base hover:text-[#C29979] hover:bg-amber-50 transition-colors">Smáréttir</a>
                  <a href="/pantanir" className="block px-4 py-2 text-stone-600 font-serif text-base hover:text-[#C29979] hover:bg-amber-50 transition-colors">Annað</a>
                </div>
              )}
            </div>
          </div>

          <div className="flex items-center space-x-1">
            <button onClick={() => window.location.href = '/hafa-samband'} className={NAV_LINK}>Hafa samband</button>
            <button onClick={() => window.location.href = '/umokkur'} className={NAV_LINK}>Um okkur</button>
            <button
              onClick={() => window.location.href = '/karfa'}
              className="relative flex items-center gap-1.5 text-base text-stone-600 font-serif hover:text-[#C29979] px-3 py-2 rounded transition-colors ml-2"
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M9 7V6a3 3 0 016 0v1M3 7h18l-2 13H5L3 7z"/></svg>
              Karfa
              {cartCount > 0 && (
                <span className="absolute -top-1 -right-1 bg-[#C29979] text-white text-xs font-bold w-5 h-5 rounded-full flex items-center justify-center">
                  {cartCount}
                </span>
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {mobileMenuOpen && (
        <div className="md:hidden border-t border-amber-100 bg-white">
          <div className="px-4 py-3 space-y-1">
            <a href="/" className="block px-3 py-2.5 text-stone-600 font-serif text-base hover:text-[#C29979] hover:bg-amber-50 rounded-lg transition-colors">Forsíða</a>

            <div>
              <button
                onClick={() => setDropdownOpen(!dropdownOpen)}
                className="w-full flex items-center justify-between px-3 py-2.5 text-stone-600 font-serif text-base hover:text-[#C29979] hover:bg-amber-50 rounded-lg transition-colors"
              >
                Vörur <ArrowDropDownIcon fontSize="small" />
              </button>
              {dropdownOpen && (
                <div className="ml-4 mt-1 space-y-1">
                  <a href="/braud" className="block px-3 py-2 text-stone-500 font-serif text-base hover:text-[#C29979] hover:bg-amber-50 rounded-lg">Brauð</a>
                  <a href="/braudmeti" className="block px-3 py-2 text-stone-500 font-serif text-base hover:text-[#C29979] hover:bg-amber-50 rounded-lg">Brauðmeti</a>
                  <a href="/bakkelsi" className="block px-3 py-2 text-stone-500 font-serif text-base hover:text-[#C29979] hover:bg-amber-50 rounded-lg">Bakkelsi</a>
                  <a href="/smurt" className="block px-3 py-2 text-stone-500 font-serif text-base hover:text-[#C29979] hover:bg-amber-50 rounded-lg">Smurt</a>
                </div>
              )}
            </div>

            <a href="/kokur" className="block px-3 py-2.5 text-stone-600 font-serif text-base hover:text-[#C29979] hover:bg-amber-50 rounded-lg transition-colors">Kökur</a>

            <div>
              <button
                onClick={() => setDropdownOpen2(!dropdownOpen2)}
                className="w-full flex items-center justify-between px-3 py-2.5 text-stone-600 font-serif text-base hover:text-[#C29979] hover:bg-amber-50 rounded-lg transition-colors"
              >
                Pantanir <ArrowDropDownIcon fontSize="small" />
              </button>
              {dropdownOpen2 && (
                <div className="ml-4 mt-1 space-y-1">
                  <a href="/kokur" className="block px-3 py-2 text-stone-500 font-serif text-base hover:text-[#C29979] hover:bg-amber-50 rounded-lg">Kökur</a>
                  <a href="/smarettir" className="block px-3 py-2 text-stone-500 font-serif text-base hover:text-[#C29979] hover:bg-amber-50 rounded-lg">Smáréttir</a>
                  <a href="/pantanir" className="block px-3 py-2 text-stone-500 font-serif text-base hover:text-[#C29979] hover:bg-amber-50 rounded-lg">Annað</a>
                </div>
              )}
            </div>

            <a href="/hafa-samband" className="block px-3 py-2.5 text-stone-600 font-serif text-base hover:text-[#C29979] hover:bg-amber-50 rounded-lg transition-colors">Hafa samband</a>
            <a href="/umokkur" className="block px-3 py-2.5 text-stone-600 font-serif text-base hover:text-[#C29979] hover:bg-amber-50 rounded-lg transition-colors">Um okkur</a>

            <a href="/karfa" className="flex items-center gap-2 px-3 py-2.5 text-stone-600 font-serif text-base hover:text-[#C29979] hover:bg-amber-50 rounded-lg transition-colors">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M9 7V6a3 3 0 016 0v1M3 7h18l-2 13H5L3 7z"/></svg>
              Karfa
              {cartCount > 0 && (
                <span className="bg-[#C29979] text-white text-xs font-bold px-1.5 py-0.5 rounded-full">{cartCount}</span>
              )}
            </a>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
